module.exports = __webpack_public_path__ + "static/Mascot_Stand_Black_Stroke-d4d545ea8c6c1a346f0ff0eda49779f2.svg";